/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateResourceObjectInsuranceRequest,
  DeleteResourceObjectInsuranceRequest,
  GetResourceObjectInsurancesParams,
  ResourceObjectInsuranceDto,
  UpdateResourceObjectInsuranceRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetResourceObjectInsurancesUrl = (params?: GetResourceObjectInsurancesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObjectInsurance/GetResourceObjectInsurances?${stringifiedParams}` : `/api/ResourceObjectInsurance/GetResourceObjectInsurances`
}

export const getResourceObjectInsurances = async (params?: GetResourceObjectInsurancesParams, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectInsuranceDto[]> => {

  return customInstance<ResourceObjectInsuranceDto[]>(getGetResourceObjectInsurancesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceObjectInsurancesQueryKey = (params?: GetResourceObjectInsurancesParams,) => {
    return [
    `/api/ResourceObjectInsurance/GetResourceObjectInsurances`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceObjectInsurancesQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectInsurancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectInsurances>>> = ({ signal }) => getResourceObjectInsurances(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceObjectInsurancesQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectInsurances>>>
export type GetResourceObjectInsurancesQueryError = ErrorType<unknown>


export function useGetResourceObjectInsurances<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectInsurancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectInsurances>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectInsurances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectInsurances<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectInsurances>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectInsurances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectInsurances<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectInsurances<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectInsurancesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceObjectInsurancesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectInsurancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectInsurances>>> = ({ signal }) => getResourceObjectInsurances(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceObjectInsurancesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectInsurances>>>
export type GetResourceObjectInsurancesSuspenseQueryError = ErrorType<unknown>


export function useGetResourceObjectInsurancesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectInsurancesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectInsurancesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectInsurancesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectInsurancesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectInsurancesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectInsurances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectInsurancesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateResourceObjectInsuranceUrl = () => {




  return `/api/ResourceObjectInsurance/CreateResourceObjectInsurance`
}

export const createResourceObjectInsurance = async (createResourceObjectInsuranceRequest: CreateResourceObjectInsuranceRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectInsuranceDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectInsuranceDto>(getCreateResourceObjectInsuranceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createResourceObjectInsuranceRequest)
  }
);}





export const getCreateResourceObjectInsuranceMutationKey = () => ['createResourceObjectInsurance'] as const;

export const getCreateResourceObjectInsuranceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectInsurance>>, TError,CreateResourceObjectInsuranceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectInsurance>>, TError,CreateResourceObjectInsuranceMutationVariables, TContext> => {

const mutationKey = getCreateResourceObjectInsuranceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceObjectInsurance>>, CreateResourceObjectInsuranceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResourceObjectInsurance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceObjectInsuranceMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceObjectInsurance>>>
    export type CreateResourceObjectInsuranceMutationBody = BodyType<CreateResourceObjectInsuranceRequest>
    export type CreateResourceObjectInsuranceMutationError = ErrorType<unknown>
    export type CreateResourceObjectInsuranceMutationVariables = {data: BodyType<CreateResourceObjectInsuranceRequest>}

    export const useCreateResourceObjectInsurance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectInsurance>>, TError,CreateResourceObjectInsuranceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResourceObjectInsurance>>,
        TError,
        CreateResourceObjectInsuranceMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResourceObjectInsuranceMutationOptions(options), queryClient);
    }
    export const getUpdateResourceObjectInsuranceUrl = () => {




  return `/api/ResourceObjectInsurance/UpdateResourceObjectInsurance`
}

export const updateResourceObjectInsurance = async (updateResourceObjectInsuranceRequest: UpdateResourceObjectInsuranceRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectInsuranceDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectInsuranceDto>(getUpdateResourceObjectInsuranceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateResourceObjectInsuranceRequest)
  }
);}





export const getUpdateResourceObjectInsuranceMutationKey = () => ['updateResourceObjectInsurance'] as const;

export const getUpdateResourceObjectInsuranceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectInsurance>>, TError,UpdateResourceObjectInsuranceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectInsurance>>, TError,UpdateResourceObjectInsuranceMutationVariables, TContext> => {

const mutationKey = getUpdateResourceObjectInsuranceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResourceObjectInsurance>>, UpdateResourceObjectInsuranceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateResourceObjectInsurance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResourceObjectInsuranceMutationResult = NonNullable<Awaited<ReturnType<typeof updateResourceObjectInsurance>>>
    export type UpdateResourceObjectInsuranceMutationBody = BodyType<UpdateResourceObjectInsuranceRequest>
    export type UpdateResourceObjectInsuranceMutationError = ErrorType<unknown>
    export type UpdateResourceObjectInsuranceMutationVariables = {data: BodyType<UpdateResourceObjectInsuranceRequest>}

    export const useUpdateResourceObjectInsurance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectInsurance>>, TError,UpdateResourceObjectInsuranceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateResourceObjectInsurance>>,
        TError,
        UpdateResourceObjectInsuranceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResourceObjectInsuranceMutationOptions(options), queryClient);
    }
    export const getDeleteResourceObjectInsuranceUrl = () => {




  return `/api/ResourceObjectInsurance/DeleteResourceObjectInsurance`
}

export const deleteResourceObjectInsurance = async (deleteResourceObjectInsuranceRequest: DeleteResourceObjectInsuranceRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDeleteResourceObjectInsuranceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteResourceObjectInsuranceRequest)
  }
);}





export const getDeleteResourceObjectInsuranceMutationKey = () => ['deleteResourceObjectInsurance'] as const;

export const getDeleteResourceObjectInsuranceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResourceObjectInsurance>>, TError,DeleteResourceObjectInsuranceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteResourceObjectInsurance>>, TError,DeleteResourceObjectInsuranceMutationVariables, TContext> => {

const mutationKey = getDeleteResourceObjectInsuranceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteResourceObjectInsurance>>, DeleteResourceObjectInsuranceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteResourceObjectInsurance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteResourceObjectInsuranceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResourceObjectInsurance>>>
    export type DeleteResourceObjectInsuranceMutationBody = BodyType<DeleteResourceObjectInsuranceRequest>
    export type DeleteResourceObjectInsuranceMutationError = ErrorType<unknown>
    export type DeleteResourceObjectInsuranceMutationVariables = {data: BodyType<DeleteResourceObjectInsuranceRequest>}

    export const useDeleteResourceObjectInsurance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResourceObjectInsurance>>, TError,DeleteResourceObjectInsuranceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteResourceObjectInsurance>>,
        TError,
        DeleteResourceObjectInsuranceMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteResourceObjectInsuranceMutationOptions(options), queryClient);
    }
